/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import _ from "lodash";
import YouTube, { Options } from "react-youtube";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import ShowLess from "../../partials/ShowLess";
import { Link } from "react-router-dom";
import styles from "./explore.module.scss";
import { contactEmail } from "../../shared";

const options = _.sortBy(require("../../constants/scenes.json"), "name");

const opts: Options = {
  height: "600",
  width: "100%",
  playerVars: {
    autoplay: 1,
    rel: 0,
  },
};

class Explore extends React.Component<any, any> {
  state = {
    initialScene: options[0].name,
    warning: "",
  };

  handleChange = (e) => {
    this.props.onSceneChange(e.target.value);
  };

  handleViewSelectorChange = (e) => {
    this.props.onViewChange(e.target.value);
  };

  render() {
    const { sceneId = options[0].name, frame = 0, view } = this.props;
    const scene = options.find((opt) => opt.name === sceneId) || options[0];

    return (
      <ShowLess className="content pb-2em text-justify">
        <p>
          On this page we provide tools to preview some of the scenes of the
          nuScenes dataset without having to download the entire dataset.
        </p>
        <h3>Usage</h3>
        <p>
          Below you see the LIDAR point cloud of an example scene in nuScenes.
          To navigate use the SW keys to move backward and forward, AD keys to
          move left and right, QE keys to move up and down, the arrow keys for
          rotation and +- to move forward and backward in time between
          keyframes. You can also use the slider at the bottom to jump to
          different keyframes. Loading a scene may take between 5-20s. To link
          to a particular scene or frame use the link{" "}
          <Link to={`/nuscenes?sceneId=${this.state.initialScene}&frame=0`}>
            https://www.nuscenes.org/nuscenes?sceneId={this.state.initialScene}
            &amp;frame=0
          </Link>
          , where {this.state.initialScene} identifies the scene and 0 is the
          first frame. Your browser must support WebGL. Please contact{" "}
          <a href={"mailto:" + contactEmail}>{contactEmail}</a> if you are
          experiencing technical problems. Note that the tool may crash on some
          versions of Chrome.
        </p>
        <form autoComplete="off" className={styles.form}>
          {this.state.warning && (
            <p className="warning-message">{this.state.warning}</p>
          )}
          <FormControl className={styles.width}>
            <InputLabel htmlFor="viewSelector">View</InputLabel>
            <Select
              value={view}
              onChange={this.handleViewSelectorChange}
              inputProps={{
                name: "viewSelector",
                id: "viewSelector-options",
              }}
              className={styles.width}
            >
              <MenuItem value="regular">nuScenes</MenuItem>
              <MenuItem value="lidar">nuScenes-lidarseg</MenuItem>
            </Select>
          </FormControl>
          <FormControl className={styles.width}>
            <InputLabel htmlFor="scenes">Scenes</InputLabel>
            <Select
              value={scene.name}
              onChange={this.handleChange}
              inputProps={{
                name: "scenes",
                id: "scenes-options",
              }}
              className={styles.width}
            >
              {options.map((option, index) => (
                <MenuItem value={option.name} key={index}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className={styles.text}>Best present on computer</div>
        </form>
        {this.state.initialScene && (
          <>
            <iframe
              loading="lazy"
              className={styles.iframe}
              src={`${scene.url}&frame=${frame}`}
              allowFullScreen={true}
            />
            <YouTube
              videoId={view === "lidar" ? scene.lidarVideo : scene.video}
              opts={opts}
            />
          </>
        )}
      </ShowLess>
    );
  }
}

export default Explore;
